const formatNumber = (number, fractionDigits = 1) => {
    let formattedNumber = number;
    if (!Number.isInteger(number)) {
        formattedNumber = parseFloat(number.toFixed(fractionDigits));
    }

    return formattedNumber;
};

export default function (number, fractionDigits = 1) {
    if (Number.isNaN(number)) {
        return number;
    }

    const map = {
        B: 1000000000,
        M: 1000000,
        K: 1000
    };

    let collapsedNumber = number;
    let letter = '';
    if (number >= map.B) {
        letter = 'B';
        collapsedNumber = number / map.B;
    } else if (number >= map.M) {
        letter = 'M';
        collapsedNumber = number / map.M;
    } else if (number >= map.K) {
        letter = 'K';
        collapsedNumber = number / map.K;
    }

    return `${formatNumber(collapsedNumber, fractionDigits)}${letter}`;
}
